module.exports = __webpack_public_path__ + "static/media/mi7.adc9e94a.jpg";